import React from 'react'
import styled from 'styled-components'
import CountDonut from 'features/dashboard/charts/CountDonut'
import ChartKeyExplainer from 'features/dashboard/charts/ChartKeyExplainer'
import { font, ink } from 'features/dashboard/tokens'

const ProgressMixCard = ({
  title,
  lead,
  centreLabel,
  buckets = [],
  emptyText,
  rangeLabel,
  onOpen,
}) => {
  const shown = buckets.filter(b => Number(b.count) > 0)

  if (!shown.length) {
    return <Empty>{emptyText}{rangeLabel ? ` for ${rangeLabel}` : ''}.</Empty>
  }

  return (
    <Wrap>
      <Intro>
        {lead}
        {onOpen ? ` Select a row to see those ${centreLabel.toLowerCase()}.` : ''}
        <ExplainerSlot>
          <ChartKeyExplainer
            title={title}
            lead={lead}
            buckets={buckets}
            drillNote={onOpen ? `Select a row to open that list of ${centreLabel.toLowerCase()}.` : null}
          />
        </ExplainerSlot>
      </Intro>
      <CountDonut
        segments={buckets.map(b => ({ ...b, drill: onOpen ? b.key : undefined }))}
        centreLabel={centreLabel}
        size={132}
        stroke={18}
        onSegmentClick={onOpen ? seg => onOpen(seg) : undefined}
      />
    </Wrap>
  )
}

export default ProgressMixCard

const Wrap = styled.div`display: flex; flex-direction: column; gap: 12px; min-width: 0;`
const Intro = styled.div`
  font-size: ${font.small}; color: ${ink.mute}; line-height: 1.5;
`
const ExplainerSlot = styled.span`display: inline-flex; align-items: center; vertical-align: middle;`
const Empty = styled.div`font-size: ${font.small}; color: ${ink.mute}; line-height: 1.5; padding: 8px 0;`
